import { defineMessages } from '@edx/frontend-platform/i18n';
const messages = defineMessages({
  socialAuthProviderSignupTitle: {
    id: 'social.auth.provide.signup.title',
    defaultMessage: 'Sign up with {providerName}',
    description: 'Title that appears on the social sign up buttons i.e Sign up with Google'
  },
  socialAuthProviderSigninTitle: {
    id: 'social.auth.provide.signin.title',
    defaultMessage: 'Sign in with {providerName}',
    description: 'Title that appears on the social sign in buttons i.e Sign in with Google'
  }
});
export default messages;
//# sourceMappingURL=messages.js.map